export default "__VITE_ASSET__75db42da__"